import styled from '@emotion/styled';
import { Button, type ButtonProps } from 'antd';

export interface PrimaryButtonProps extends ButtonProps {}

const StyledPrimary = styled(Button)<PrimaryButtonProps>`
`;

export const PrimaryButton: React.FC<PrimaryButtonProps> = (props) => (
  <StyledPrimary color="primary" variant="solid" {...props} />
);
